import React from 'react';
import SelectAnOrganizationPlaceholderImage from 'apps/sigma2-ui/public/images/select-an-organization-placeholder.png';
import { S2Typography } from 'apps/sigma2-ui/src/components/ui/Typography';
import { Spacing } from 'apps/sigma2-ui/src/components/ui/Spacing';
import { useLanguage } from 'apps/sigma2-ui/src/lib/hooks/useLanguage';

export const SelectAnOrganizationPlaceholder = () => {
  const language = useLanguage();

  return (
    <Spacing
      direction={'vertical'}
      size={'xs'}
      className="items-center h-[60vh]"
      data-testid="select-an-organization-placeholder"
    >
      <img
        src={SelectAnOrganizationPlaceholderImage}
        alt="Select an organization"
      />

      <span className="-mt-16">
        <S2Typography
          translatedContent={language.selectAnOrganizationPlaceholder()}
          variant={'headline-5-alt'}
        />
      </span>
    </Spacing>
  );
};
